// src/components/NavigatorNav.tsx

import React from 'react';

const NavigatorNav: React.FC = () => {
  return (
    <nav className="bg-white shadow-sm border-b border-gray-200 mb-8">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex items-center">
            <a href="https://healthtechcompliance.com" className="text-lg font-bold text-blue-600 hover:text-blue-700">
              ← Healthcare Technology Compliance
            </a>
          </div>
          <div className="hidden md:flex space-x-6 text-sm">
            <a href="https://healthtechcompliance.com/#about" className="text-gray-700 hover:text-blue-600 font-medium">
              About
            </a>
            <a href="https://healthtechcompliance.com/resources.html" className="text-gray-700 hover:text-blue-600 font-medium">
              Resources
            </a>
            <a href="https://healthtechcompliance.com/#contribute" className="text-gray-700 hover:text-blue-600 font-medium">
              Contribute
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavigatorNav;
